"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Leaflet = void 0;
var utils_1 = require("./utils");
var Leaflet = /** @class */ (function () {
    function Leaflet(element) {
        this.url = 'https://maps.oebb.at/osm-liberty-oebb-europe';
        this.styleUrl = (0, utils_1.getResourceUrl)('css/site-partial-leaflet.min.css');
        this.attributionPrefix = '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a>';
        this.attribution = '<a href="http://openmaptiles.org/" rel="nofollow">© OpenMapTiles</a> <a href="http://www.openstreetmap.org/copyright" rel="nofollow">© OpenStreetMap contributors</a>';
        this.minZoom = 0;
        this.maxZoom = 14;
        this.zoom = 7;
        this.center = [47.7313, 13.5479];
        this.isReady = false;
        this.scrollNoteText = 'Strg + Scrollen zum Zoomen der Karte';
        this.hasTileError = false;
        this.element = element;
        this.url = this.element.dataset.url ? this.element.dataset.url.replace(/\/$/, '') : this.url;
    }
    /**
     * Only use this function if Leaflet is not included in the module, to know when leaflet script is ready.
     *
     * @param url      URL to leaflet script.
     * @param callback Called if Leaflet is loaded.
     */
    Leaflet.prototype.loadScript = function (url, callback) {
        var _this = this;
        (0, utils_1.loadScript)(url, 'leaflet', function () {
            _this.isReady = true;
            callback();
        });
    };
    Leaflet.prototype.initDom = function () {
        if (this.styleUrl)
            (0, utils_1.loadStyle)(this.styleUrl, 'all', 'leaflet-styles');
        if (this.styleInline)
            this.addOebbLeafletStyles();
        this.map = L.map(this.element, {
            zoomControl: false,
        });
        this.map.attributionControl.setPrefix(this.attributionPrefix);
        this.mainLayer = L.tileLayer("".concat(this.url, "/{z}/{x}/{y}.png"), {
            attribution: this.attribution,
            minZoom: this.minZoom,
            maxZoom: this.maxZoom,
        }).addTo(this.map);
        this.map.setView(this.center, this.zoom);
        new L.Control.Zoom({ position: 'bottomright' }).addTo(this.map);
    };
    Leaflet.prototype.initListeners = function () { };
    Leaflet.prototype.initScrollBehavior = function () {
        var _this = this;
        // Disable dragging on mobile
        if (L.Browser.mobile) {
            this.map.dragging.disable();
            // @ts-ignore TODO un-ignore when typings are updated
            this.map.tapHold.disable();
        }
        // Disable scrolling, only allow with ctrl + wheel
        if (!L.Browser.mobile) {
            this.map.scrollWheelZoom.disable();
            var zoomEnabled_1 = false;
            var supportsWheel_1 = false;
            var onMapScroll = function (e) {
                // Only fire once if 'wheel' is supported
                if (e.type == 'wheel') {
                    supportsWheel_1 = true;
                }
                else if (supportsWheel_1) {
                    return;
                }
                var scrollNoteElement = _this.element.querySelector('.js-leaflet-scroll-note');
                if (!zoomEnabled_1) {
                    scrollNoteElement.classList.remove('leaflet-scroll-note--hidden');
                    setTimeout(function () { return scrollNoteElement.classList.add('leaflet-scroll-note--hidden'); }, 2000);
                }
                else {
                    e.stopPropagation();
                    e.preventDefault();
                }
            };
            document.addEventListener('keydown', function (e) {
                if (e.keyCode == 17 && !zoomEnabled_1) {
                    _this.map.scrollWheelZoom.enable();
                    zoomEnabled_1 = true;
                }
            });
            document.addEventListener('keyup', function (e) {
                if (e.keyCode == 17) {
                    _this.map.scrollWheelZoom.disable();
                    zoomEnabled_1 = false;
                }
            });
            this.element.addEventListener('wheel', onMapScroll);
            this.element.addEventListener('mousewheel', onMapScroll);
            this.element.addEventListener('DOMMouseScroll', onMapScroll);
            var scrollNoteElement = document.createElement('div');
            scrollNoteElement.classList.add('js-leaflet-scroll-note');
            scrollNoteElement.classList.add('leaflet-scroll-note');
            scrollNoteElement.classList.add('leaflet-scroll-note--hidden');
            var scrollNoteParagraph = document.createElement('p');
            var scrollNoteText = document.createTextNode(this.scrollNoteText);
            scrollNoteParagraph.appendChild(scrollNoteText);
            scrollNoteElement.appendChild(scrollNoteParagraph);
            this.element.appendChild(scrollNoteElement);
        }
    };
    Leaflet.prototype.initErrorTileEventBehavior = function (zoom) {
        var _this = this;
        if (zoom === void 0) { zoom = 14; }
        this.map.on('zoomend', function () {
            if (_this.hasTileError) {
                _this.map.setZoom(zoom);
                _this.hasTileError = false;
            }
        });
        this.mainLayer.on('tileerror', function (e) {
            _this.hasTileError = true;
            _this.map.setZoom(zoom);
        });
    };
    Leaflet.prototype.addOebbLeafletStyles = function () {
        if (document.querySelector('#js-oebb-leaflet-styles'))
            return;
        var style = document.createElement('style');
        style.id = 'js-oebb-leaflet-styles';
        this.element.classList.add('oebb-leaflet');
        style.innerHTML = this.styleInline;
        document.head.appendChild(style);
    };
    return Leaflet;
}());
exports.Leaflet = Leaflet;
